<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Turno"
              v-model="form.filters.descricao"
              outlined
              maxlength="25"
              dense
              @keyup.enter="buscarTurnos"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarTurnos"
          ></sca-select-ativo>
        </v-row>
        <v-row class="d-flex justify-center mt-0">
          <v-col cols="3">
            <v-text-field
              label="Hora de Início"
              v-model="form.filters.horaInicio"
              outlined
              dense
              v-mask="'##:##'"
              @keyup.enter="buscarTurnos"
              :rules="[(h) => horaValida(h)]"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Hora de Término"
              v-model="form.filters.horaFim"
              outlined
              dense
              v-mask="'##:##'"
              @keyup.enter="buscarTurnos"
              :rules="[(h) => horaValida(h)]"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarTurnos()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterTurno()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="table.noDataText"
      >
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarTurno(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterTurno(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo? 'mdi-toggle-switch': 'mdi-toggle-switch-off'}`"
            :small="true"
            @click="inativarAtivarTurno(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarTurnoDialog
      :visible="dialogManterTurno.visible"
      :content="dialogManterTurno.content"
      :edit="dialogManterTurno.edit"
      @onClose="dialogManterTurno.close()"
      @onSave="buscarTurnos()"
    ></CadastrarEditarTurnoDialog>
    <VisualizarTurnoDialog
      v-if="dialogVisualizarTurno.visible"
      :visible="dialogVisualizarTurno.visible"
      :content="dialogVisualizarTurno.content"
      @onClose="dialogVisualizarTurno.close()"
    ></VisualizarTurnoDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Turno } from '~/commons/classes/turno';
import TurnoService from '~/services/turno.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarTurnoDialog from "./dialogs/CadastrarEditarTurnoDialog.vue";
import VisualizarTurnoDialog from "./dialogs/VisualizarTurnoDialog.vue";

export default {
  name: "ManterTurnosView",
  mixins: [TurnoService, datatablesMixin],
  components: {
    CadastrarEditarTurnoDialog,
    VisualizarTurnoDialog,
  },
  data: () => ({
    dialogManterTurno: Dialog.Build(),
    dialogVisualizarTurno: Dialog.Build(),
    form: {
      filters: {
        descricao: null,
        ativo: null,
        horaInicio: null,
        horaFim: null,
      },
    },
    table: {
      headers: [
        { text: 'Turno', align: 'center', value: 'descricao' },
        { text: 'Hora de Início', align: 'center', value: 'horaInicio' },
        { text: 'Hora de Término', align: 'center', value: 'horaFim' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
      noDataText: '',
    },
  }),
  methods: {
    iniciarMensagemDeNenhumRegistroEncontrado() {
      this.table.noDataText = this.$possuiPermissao('turno.listar')
        ? ''
        : 'Não há registros a serem exibidos';
    },
    buscarTurnos() {
      this.table.noDataText = 'Não há registros a serem exibidos';
      this.$buscarTurnos({ params: this.form.filters }).then(({ data }) => (this.table.itens = data.itens));
    },
    openDialogManterTurno(turno) {
      turno
        ? this.$visualizarTurno(turno.id).then(
          ({ data }) => this.dialogManterTurno.open(new Turno(data.resposta), true))
        : this.dialogManterTurno.open(Turno.Build());
    },
    openDialogVisualizarTurno(turno) {
      this.$visualizarTurno(turno.id).then(
        ({ data }) => this.dialogVisualizarTurno.open(new Turno(data.resposta)));
    },
    inativarAtivarTurno(turno) {
      this.$swal({
        text: `Deseja ${turno.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarTurno(turno.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarTurnos();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    horaValida(h) {
      if (!h) return true;
      const [hora, minuto] = h.split(':').filter(h => h.length === 2).map(x => parseInt(x));
      const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
      return condicao || 'Hora inválida';
    },
  },
  mounted() {
    this.iniciarMensagemDeNenhumRegistroEncontrado();
  }
};
</script>
